import React from "react";
import EvolutionLabel from "./evolutionLabel";
import { StringUtils } from '../../utils/strings';

const TableCellWithEvolution = ({cellValue, evolutionValue, refValue, fillWithZeros = false}) => {
    return (
        <div className="spaced-around-container">
            <span>
                {StringUtils.getUSnumbersFormating(cellValue, fillWithZeros)}
            </span>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                {StringUtils.isNumeric(evolutionValue) && <EvolutionLabel value={evolutionValue}/>}
                <span style={{fontSize: "0.75em", marginTop: "1em"}}>
                    vs.&nbsp;
                    {StringUtils.getUSnumbersFormating(refValue, fillWithZeros)}
                </span>
            </div>
        </div>
    )
}

export default TableCellWithEvolution;